function getCurrentDate() {
	const current = new Date()

	return `${current.getFullYear()}-${
		current.getMonth() + 1
	}-${current.getDate()}`
}

export default getCurrentDate
